import apiUseCases from "@src/cloud-connect/api";
import store from "@src/reducers/store";
import { UnitsResponse } from "@src/types/units";

export interface GetUnitsResult {
  success: boolean;
  data?: UnitsResponse;
  error?: string;
}

export const getUnitsUseCase = async (): Promise<GetUnitsResult> => {
  const namespace = store.getState().yourSlice.authContext?.customerNamespace;
  if (!namespace) {
    return { success: false, error: "Missing customer namespace" };
  }

  const response = await apiUseCases.getUnits({ namespace });
  if (!response.success || !("data" in response)) {
    return {
      success: false,
      error: "error" in response ? response.error : "Failed to fetch units",
    };
  }

  return { success: true, data: response.data };
};
